import Form from 'mobx-react-form';
import plugins from './plugins';

const fields = ['users', 'users[].email'];

const labels = {
    users: 'All Recipients',
    'users[].email': 'Email',
};

const placeholders = {
    users: 'All Recipients',
    'users[].email': 'Enter email address',
};

const rules = {
    'users[].email': 'required|email|string',
};


class EmailsForm extends Form {
    constructor(setup, options) {

        super(
            { fields, placeholders, rules, labels, ...setup },
            { plugins, ...options }
        );
    }
}

export default EmailsForm;
